import { render, staticRenderFns } from "./listarFamilia.vue?vue&type=template&id=18060367&scoped=true&"
import script from "./listarFamilia.vue?vue&type=script&lang=js&"
export * from "./listarFamilia.vue?vue&type=script&lang=js&"
import style0 from "./listarFamilia.vue?vue&type=style&index=0&id=18060367&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18060367",
  null
  
)

export default component.exports